import React from 'react'
import "./Header.scss"
const Header = () => {
    return (
        <header className="header">
            <h1>פרויקט מקפצה לדיגיטל: עסקים עוברים לאונליין</h1>
            <h2>של ידיעות אחרונות ו-ynet, בחסות בנק הפועלים יוצא לדרך</h2>
            <h3>
                רוצים לעשות קפיצת מדרגה בזירה הדיגיטלית? ללמוד כיצד ניתן להגדיל הכנסות באמצעות פעילות באונליין? 
                השאירו פרטים ואולי תהיו בין 100 העסקים שייבחרו לקבל לווי אישי ומקצועי ע"י צוות המומחים של בית הספר לשיווק דיגיטלי - Digitalent
                באחד מן הנושאים המוצעים
            </h3>


            <div className="woman"></div>
            <div className="man"></div>
        </header>
    )
}

export default Header
